"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PRESET = {
    medium: {
        type: undefined,
        key: "DUMMY_MEDIUM",
        period: "DM",
        longTitle: ""
    },
    frequency: 1,
    pi: 0,
    conditions: {
        "online": {
            "adFormat": "AGOF_Werbeform_0",
            "pricing": "TryFixPrice"
        }
    },
    group: ""
};
//# sourceMappingURL=DefaultPreset.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/DefaultPreset.js
// module id = 23
// module chunks = 0